export const ORTHOGRAPHIQ_APP_CONTEXT = 'orthographIQ-app-context-realease-on-18092023';
export const ANDROID_REFERRER_KEYWORD = 'android-app';
export const WEB_LINK_REFERRER_KEYWORD = 'http';
